import React from "react";
import { Link } from "react-router-dom";
import Loading from "../../Components/Loading";
import { ToDateJalali } from "../../Utils/functions";
import { useListAds } from "./Hooks";
import { FiEdit } from "react-icons/fi";
import Paginate from "../../Components/Paginate";
const AdsList = () => {
  const { data, loading, searchParams } = useListAds();

  const renderstatus = (status) => {
    switch (status) {
      case "draft":
        return {
          title: "پیش نویس",
          status: "process",
        };
      case "peyerror":
      case "waittopey":
        return {
          title: "عدم پرداخت",
          status: "error",
        };
      case "inprocess":
        return {
          title: "در حال بررسی اولیه",
          status: "process",
        };
      case "visible":
        return {
          title: "منتشر شده",
          status: "success",
        };
      case "hidden":
        return {
          title: "غیر فعال",
          status: "error",
        };
      case "reject":
        return {
          title: "رد شده",
          status: "error",
        };
      case "edited":
        return {
          title: "منتظر بررسی مجدد",
          status: "process",
        };
    }
    return {};
  };
  const renderBody = () => {
    if (loading) {
      return (
        <div className="row">
          <Loading count={2} col={12} height={"350px"} />
        </div>
      );
    } else {
      if (data.data.length == 0) {
        return (
          <div className="empty">
            <img src={require("../../Assets/images/empty.png")} />
            <p className="fs-12 mt-2 fw-500 text-center sad">
              متاسفانه هنوز آگهی ثبت نشده است.
            </p>
            <div className="d-flex justify-content-center">
              <Link to={"/ads-submit"} className="text-center fs-14 new">
                {" "}
                ثبت آگهی
              </Link>
            </div>
          </div>
        );
      } else {
        return (
          <table className="table">
            <thead>
              <tr>
                <th className="d-lg-table-cell d-lg-table-cell d-none">
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">کد</p>
                </th>
                <th className="d-lg-table-cell d-lg-table-cell d-none">
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">عنوان</p>
                </th>
                <th className="d-lg-table-cell d-lg-table-cell d-none">
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">
                    دسته بندی
                  </p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">
                    تاریخ ثبت
                  </p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 fw-semi-normal">وضعیت</p>
                </th>
                <th>
                  <p className="fs-12 text-blue mb-0 text-center fw-semi-normal">
                    جزيیات
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((item, count) => {
                return (
                  <tr key={count}>
                    <td className=" d-lg-table-cell ">
                      <span className="fs-12 text-blue">{item.code}</span>
                    </td>
                    <td className=" d-lg-table-cell ">
                      <p className="fs-12 text-blue mb-0">{item.title}</p>
                    </td>
                    <td className=" d-lg-table-cell ">
                      <p className="fs-12 text-blue mb-0 ">
                        {item?.category?.title || "-----"}
                      </p>
                    </td>
                    <td>
                      <p className="fs-12 text-blue mb-0">
                        {ToDateJalali(item.created_at)}
                      </p>
                    </td>
                    <td>
                      <p className="fs-12 text-blue mb-0">
                        <span
                          className={`${
                            renderstatus(item.status)["status"]
                          } ml-5`}
                        />
                        {renderstatus(item.status)["title"]}
                      </p>
                    </td>
                    <td className="btn-td text-center">
                      <div className="actions">
                        <Link
                          to={`${item.id}`}
                          className="btn-modal"
                          data-type="show">
                          مشاهده
                        </Link>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        );
        return;
      }
    }
  };
  return (
    <div className=" ads-list-wrapper row overflow-auto mt-3 mb-3">
      {renderBody()}
      <Paginate
        data={data}
        loading={loading}
        filters={[]}
        searchParams={searchParams}
        style={{ marginTop: "10px" }}
      />
    </div>
  );
};

export default AdsList;
